export const FRESHDESK_FAQS = {
  DEFAULT: '80000009969',
};
